const API_BASE = process.env.REACT_APP_API_URL?.replace(/\/$/, "") || "";

export const DEFAULT_LOGO = "/images/asso_placeholder.webp";
export const DEFAULT_COVER = "/images/asso_placeholder.webp";

export const DEMO_ROLE_IDS = new Set([3, 4]);

export const emptySectionForm = {
  nom_section: "",
  discipline_section: "",
  logo_section: "",
  photoURL: "",
  responsable_section: "",
  tel_section: "",
  mail_section: "",
  siteweb_section: "",
  adresse_section: "",
  facebook_section: "",
  instagram_section: "",
  about_content: "",
  header1_URL: "",
  header2_URL: "",
  carrousel_id: "",
};

export function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch {
    return null;
  }
}

export function isDemoMode() {
  const user = getStoredUser();
  return DEMO_ROLE_IDS.has(Number(user?.role_id));
}

export function getFallbackSectionId(sectionId) {
  if (sectionId) return Number(sectionId);

  const user = getStoredUser();

  return user?.section_id ? Number(user.section_id) : null;
}

export function isExternalUrl(url) {
  try {
    const parsed = new URL(url);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
}

export function resolveMediaUrl(url, fallback = DEFAULT_COVER) {
  if (!url) return fallback;

  const value = String(url).trim();

  if (!value) return fallback;

  if (
    isExternalUrl(value) ||
    value.startsWith("data:") ||
    value.startsWith("blob:")
  ) {
    return value;
  }

  if (value.startsWith("/uploads")) {
    return `${API_BASE}${value}`;
  }

  if (value.startsWith("/")) {
    return value;
  }

  return value;
}

export function mapSectionToForm(section) {
  return {
    nom_section: section?.nom_section || "",
    discipline_section: section?.discipline_section || "",
    logo_section: section?.logo_section || "",
    photoURL: section?.photoURL || "",
    responsable_section: section?.responsable_section || "",
    tel_section: section?.tel_section || "",
    mail_section: section?.mail_section || "",
    siteweb_section: section?.siteweb_section || "",
    adresse_section: section?.adresse_section || "",
    facebook_section: section?.facebook_section || "",
    instagram_section: section?.instagram_section || "",
    about_content: section?.about_content || "",
    header1_URL: section?.header1_URL || "",
    header2_URL: section?.header2_URL || "",
    carrousel_id: section?.carrousel_id || "",
  };
}

export function buildSectionPayload(sectionId, formData) {
  return {
    id: sectionId,
    nom_section: formData.nom_section,
    discipline_section: formData.discipline_section,
    logo_section: formData.logo_section,
    photoURL: formData.photoURL,
    responsable_section: formData.responsable_section,
    tel_section: formData.tel_section,
    mail_section: formData.mail_section,
    siteweb_section: formData.siteweb_section,
    adresse_section: formData.adresse_section,
    facebook_section: formData.facebook_section,
    instagram_section: formData.instagram_section,
    about_content: formData.about_content,
    header1_URL: formData.header1_URL,
    header2_URL: formData.header2_URL,
    carrousel_id: formData.carrousel_id ? Number(formData.carrousel_id) : null,
  };
}

export function stripHtml(html = "") {
  return String(html)
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function getSectionCompletion(formData) {
  const fields = [
    "nom_section",
    "discipline_section",
    "logo_section",
    "photoURL",
    "responsable_section",
    "tel_section",
    "mail_section",
    "adresse_section",
    "about_content",
    "header1_URL",
    "header2_URL",
  ];

  const completed = fields.filter((field) => {
    if (field === "about_content") {
      return stripHtml(formData[field]).length > 0;
    }

    return String(formData[field] || "").trim().length > 0;
  }).length;

  const total = fields.length;

  return {
    completed,
    total,
    percent: total ? Math.round((completed / total) * 100) : 0,
  };
}

export function getPublicLinksCount(formData) {
  return [
    formData.siteweb_section,
    formData.facebook_section,
    formData.instagram_section,
  ].filter((value) => String(value || "").trim()).length;
}